import { Stack, Text, Title } from "@mantine/core";
import { LinkSentIcon } from "../../shared/svg";
import { useTranslation } from "react-i18next";

export const LinkSentPage = () => {
  const { t } = useTranslation();

  return (
    <Stack align="stretch" justify="center" gap="24px">
      <center>
        <LinkSentIcon />
      </center>
      <Title size={36}>{t("link_sent_title")}</Title>
      <Text c="dimmed" size="md">
        {t("link_sent_description")}
      </Text>
    </Stack>
  );
};
